// extracted by mini-css-extract-plugin
module.exports = {"muteButtonIcon":"MuteButton_muteButtonIcon__5b5bi"};